import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { labelsToUrl } from "../Api/../Prelude.fs.js";
import { ofList } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { ofList as ofList_1 } from "../fable_modules/fable-library-js.4.24.0/Set.js";
import { map as map_1, head, tail, length, isEmpty, ofArray, empty, singleton } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { createObj, comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { DomainEntity, DomainEntity__get_Id } from "../ClientTypes.fs.js";
import { RowSelection$1, Table, Row, Cell, Column, FilterType } from "./Table.fs.js";
import { DomainEntities } from "../DomainEvents.fs.js";
import { createElement } from "react";
import React from "react";
import { adminContent, ByCell, dateTimeCell, EntityName, Labels } from "./Prelude.fs.js";
import { Humanize_timeSpan, EPM_Domain_Events_Maturity__Maturity_ToProperString, EPM_Domain_Events_Action_Category__Category_ToProperString } from "../Prelude.fs.js";
import { map, defaultArg, unwrap } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { utcNow } from "../fable_modules/fable-library-js.4.24.0/DateOffset.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { append, empty as empty_1, singleton as singleton_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { count, many } from "../Api/Actions.fs.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { Create, ExportSteps, Export, AssignActionType, AssignMaturity, SetEstimatedHours, ChangeCategory, SetDependencies, AssignTarget, AddStep, Update } from "../Modals/Action.fs.js";
import { Components_ExportLabels, Components_UnDelete, Components_Delete, Components_ChangeLabels } from "../Modals/Modal.fs.js";
import { many as many_1 } from "../Api/Entities.fs.js";

function nameParam(name) {
    if (isNullOrWhiteSpace(name)) {
        return new FSharpResult$2(1, ["name"]);
    }
    else {
        return new FSharpResult$2(0, [["name", name]]);
    }
}

function detailParam(detail) {
    if (isNullOrWhiteSpace(detail)) {
        return new FSharpResult$2(1, ["detail"]);
    }
    else {
        return new FSharpResult$2(0, [["detail", detail]]);
    }
}

function labelParam(key, value) {
    if (isNullOrWhiteSpace(key) && isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["labels"]);
    }
    else {
        return new FSharpResult$2(0, [["labels", labelsToUrl(ofList(singleton([key, ofList_1(singleton(value), {
            Compare: comparePrimitives,
        })]), {
            Compare: comparePrimitives,
        }))]]);
    }
}

function actionTypeParam(entityOpt) {
    if (entityOpt == null) {
        return new FSharpResult$2(1, ["actionTypeId"]);
    }
    else {
        return new FSharpResult$2(0, [["actionTypeId", DomainEntity__get_Id(entityOpt)]]);
    }
}

function columns(projectId) {
    return ofArray([new Column("name", "Name", new FilterType(0, [nameParam])), new Column("detail", "Detail", new FilterType(0, [detailParam])), new Column("caption", "Caption", undefined), new Column("labels", "Labels", new FilterType(2, [projectId, new DomainEntities(11, []), empty(), (tupledArg) => labelParam(tupledArg[0], tupledArg[1])])), new Column("category", "Category", undefined), new Column("actionType", "Action Type", new FilterType(1, [projectId, new DomainEntities(12, []), empty(), actionTypeParam])), new Column("maturity", "Maturity", undefined), new Column("estimatedCompletionTime", "Estimated Completion Time", undefined), new Column("lastModifiedOn", "Last Modified", undefined), new Column("lastModifiedBy", "Last Modified By", undefined)]);
}

function rowRender(projectId, action) {
    return new Row(action.Id, ofArray([new Cell("name", action.Name), new Cell("detail", action.Detail), new Cell("caption", action.Caption), new Cell("labels", createElement(Labels, {
        labels: action.Labels,
    })), new Cell("category", EPM_Domain_Events_Action_Category__Category_ToProperString(action.Category)), new Cell("actionType", createElement(EntityName, {
        projectId: projectId,
        entityType: new DomainEntities(12, []),
        entityId: unwrap(action.ActionTypeId),
    })), new Cell("maturity", EPM_Domain_Events_Maturity__Maturity_ToProperString(action.Maturity)), new Cell("estimatedCompletionTime", defaultArg(map(Humanize_timeSpan, action.EstimatedCompletionTime), defaultOf())), new Cell("lastModifiedOn", dateTimeCell(action.LastModified)), new Cell("lastModifiedBy", createElement(ByCell, {
        projectId: projectId,
        by: action.LastModifiedBy,
    }))]));
}

export function Actions(actionsInputProps) {
    let actions, actions_1, actions_2;
    const projectId = actionsInputProps.projectId;
    const patternInput = reactApi.useState(undefined);
    const setAction = patternInput[1];
    const action = patternInput[0];
    const patternInput_1 = reactApi.useState(empty());
    const selectedActions = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const showDeleted = patternInput_2[0];
    const patternInput_3 = reactApi.useState("");
    const patternInput_4 = reactApi.useState(empty());
    const filters = patternInput_4[0];
    let columns_1;
    const dependencies_1 = [projectId];
    columns_1 = reactApi.useMemo(() => columns(projectId), dependencies_1);
    const close = reactApi.useCallback((hasChanges) => {
        let copyOfStruct;
        setAction(undefined);
        if (hasChanges) {
            patternInput_3[1]((copyOfStruct = utcNow(), toString(copyOfStruct)));
        }
    }, []);
    const table = createElement(Table, {
        name: "Actions",
        columns: columns_1,
        initialFilters: toList(delay(() => (showDeleted ? singleton_1(["deleted", ""]) : empty_1()))),
        onFiltersChange: patternInput_4[1],
        fetchData: (actionParams) => many(projectId, empty(), actionParams),
        fetchCount: (actionParams_1) => count(projectId, actionParams_1),
        rowRender: (action_1) => rowRender(projectId, action_1),
        refresh: patternInput_3[0],
        rowSelection: new RowSelection$1(2, [patternInput_1[1]]),
    });
    const isNotEmpty = !isEmpty(selectedActions);
    const isMoreThan1 = length(selectedActions) !== 1;
    return adminContent(toList(delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["children", showDeleted ? "Hide Deleted" : "Show Deleted"], ["onClick", (_arg) => {
        patternInput_2[1](!showDeleted);
    }]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Create"], ["onClick", (_arg_1) => {
        setAction("create");
    }], ["disabled", isNotEmpty ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Update"], ["onClick", (_arg_2) => {
        setAction("update");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Auto Generate"], ["onClick", (_arg_3) => {
        setAction("autoGenerate");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Set Dependencies"], ["onClick", (_arg_4) => {
        setAction("setDependencies");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Add Step"], ["onClick", (_arg_5) => {
        setAction("addStep");
    }], ["disabled", isMoreThan1 ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Category"], ["onClick", (_arg_6) => {
        setAction("changeCategory");
    }], ["disabled", isEmpty(selectedActions) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Assign Maturity"], ["onClick", (_arg_7) => {
        setAction("assignMaturity");
    }], ["disabled", isEmpty(selectedActions) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Assign Action Type"], ["onClick", (_arg_8) => {
        setAction("assignActionType");
    }], ["disabled", isEmpty(selectedActions) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Set Estimated Hours"], ["onClick", (_arg_9) => {
        setAction("setEstimatedHours");
    }], ["disabled", isEmpty(selectedActions) ? true : showDeleted]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["children", "Change Labels"], ["onClick", (_arg_10) => {
        setAction("changeLabels");
    }], ["disabled", isEmpty(selectedActions) ? true : showDeleted]]))))), delay(() => append(showDeleted ? singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "UnDelete"], ["onClick", (_arg_11) => {
        setAction("unDelete");
    }], ["disabled", isEmpty(selectedActions)]]))))) : singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-danger"], ["children", "Delete"], ["onClick", (_arg_12) => {
        setAction("delete");
    }], ["disabled", isEmpty(selectedActions)]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-warning"], ["children", "Export"], ["onClick", (_arg_13) => {
        setAction("export");
    }]]))))), delay(() => append(singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-warning"], ["children", "Export Steps"], ["onClick", (_arg_14) => {
        setAction("exportSteps");
    }]]))))), delay(() => singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-warning"], ["children", "Export Labels"], ["onClick", (_arg_15) => {
        setAction("exportLabels");
    }]]))))))))))))))))))))))))))))))))))), table, (action != null) ? ((actions = action, (actions === "update") ? (!isEmpty(selectedActions) ? (isEmpty(tail(selectedActions)) ? createElement(Update, {
        projectId: projectId,
        action: head(selectedActions),
        close: close,
    }) : undefined) : undefined) : ((actions === "addStep") ? (!isEmpty(selectedActions) ? (isEmpty(tail(selectedActions)) ? createElement(AddStep, {
        projectId: projectId,
        action: head(selectedActions),
        close: close,
    }) : undefined) : undefined) : ((actions === "autoGenerate") ? (!isEmpty(selectedActions) ? (isEmpty(tail(selectedActions)) ? createElement(AssignTarget, {
        projectId: projectId,
        action: head(selectedActions),
        close: close,
    }) : undefined) : undefined) : ((actions === "setDependencies") ? (!isEmpty(selectedActions) ? (isEmpty(tail(selectedActions)) ? createElement(SetDependencies, {
        projectId: projectId,
        action: head(selectedActions),
        close: close,
    }) : undefined) : undefined) : ((actions === "changeLabels") ? createElement(Components_ChangeLabels, {
        projectId: projectId,
        entities: map_1((action_2) => [new DomainEntity(11, [action_2]), action_2.Labels], selectedActions),
        close: close,
    }) : ((actions === "changeCategory") ? createElement(ChangeCategory, {
        projectId: projectId,
        actions: selectedActions,
        close: close,
    }) : ((actions === "setEstimatedHours") ? createElement(SetEstimatedHours, {
        projectId: projectId,
        actions: selectedActions,
        close: close,
    }) : ((actions === "assignMaturity") ? createElement(AssignMaturity, {
        projectId: projectId,
        actions: selectedActions,
        close: close,
    }) : ((actions === "assignActionType") ? createElement(AssignActionType, {
        projectId: projectId,
        actions: selectedActions,
        close: close,
    }) : ((actions === "delete") ? ((actions_1 = map_1((Item) => (new DomainEntity(11, [Item])), selectedActions), createElement(Components_Delete, {
        projectId: projectId,
        entities: actions_1,
        close: close,
    }))) : ((actions === "unDelete") ? ((actions_2 = map_1((Item_1) => (new DomainEntity(11, [Item_1])), selectedActions), createElement(Components_UnDelete, {
        projectId: projectId,
        entities: actions_2,
        close: close,
    }))) : ((actions === "export") ? createElement(Export, {
        projectId: projectId,
        filters: filters,
        close: () => {
            close(false);
        },
    }) : ((actions === "exportLabels") ? createElement(Components_ExportLabels, {
        entityType: new DomainEntities(11, []),
        countApi: () => count(projectId, filters),
        fetchApi: (apiParams_1) => many_1(new DomainEntities(11, []), projectId, apiParams_1, filters),
        close: () => {
            close(false);
        },
    }) : ((actions === "exportSteps") ? createElement(ExportSteps, {
        projectId: projectId,
        filters: filters,
        close: () => {
            close(false);
        },
    }) : createElement(Create, {
        projectId: projectId,
        close: close,
    })))))))))))))))) : undefined);
}

